import { useQuery } from '@tanstack/react-query';
import { useApi, useAuth } from '../../hooks';
import { useParams } from 'react-router-dom';
import { ClaimRiskStrat } from 'models/claimRiskStrat';

export const useClaimRiskStrat = ({ enabled = true } = {}) => {
  const { patient: userId } = useParams();
  const { api } = useApi();
  const { isAuthenticated, loading, userToken } = useAuth();

  const fetchClaimRiskStrat = async (): Promise<ClaimRiskStrat | null> => {
    return await api({
      route: `/private/dashboard/user/${userId}/claim-risk-strat`,
      token: userToken,
    });
  };

  const { data, isLoading, isError } = useQuery<ClaimRiskStrat | null, Error>({
    queryKey: ['claim-risk-strat', userToken, userId],
    queryFn: fetchClaimRiskStrat,
    enabled: enabled && isAuthenticated && !loading && !!userToken && !!userId,
    refetchOnWindowFocus: false,
  });

  return {
    claimRiskStrat: data ?? null,
    isLoading,
    isError,
  };
};

export default useClaimRiskStrat;
